export default from './Modal';



// WEBPACK FOOTER //
// ./src/components/atoms/Modal/index.js